import { useDebounceFn, useInterval } from 'ahooks'
import { Radio } from 'antd'
import { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'

import { API } from '@/api'
import LeftArrow from '@/assets/icons/left-arrow.svg?react'
import { Divider, Trans } from '@/components'
import { extractTimePoints } from '@/models/chart'
import { formatDomain } from '@/utils/formatter'
import { TIME_UNITS_IN_SECONDS } from '@/utils/time'

import { buildChartItemData, Chart, MonitorItemData } from './MonitorChart'

export function InstanceMonitorDetailSubPage() {
  const location = useLocation()
  const instance = location.state || {}
  const [filterDuration, setFilterDuration] = useState(TIME_UNITS_IN_SECONDS.HOUR)
  const [monitorDatas, setMonitorDatas] = useState<MonitorItemData[]>([])

  const fetchDetailMonitorData = () => {
    API.getDetailMonitorData({
      chart_type: [1, 2, 3, 4, 5],
      request_id: instance?.displayID ?? 0,
      time_interval_in_sec: filterDuration,
    })
      .then((res: any) => {
        // console.log(res)
        if (res.code == 0) {
          if (instance) {
            const timePoints = extractTimePoints(res.data || [])
            setMonitorDatas(
              (res.data || []).map((it: any) => {
                return buildChartItemData(instance, it, timePoints)
              }),
            )
          }
        }
      })
      .catch(console.error)
  }
  const debouncedFetchData = useDebounceFn(fetchDetailMonitorData, {
    wait: 500,
  })

  useInterval(
    () => {
      debouncedFetchData.run()
    },
    30000,
    { immediate: true },
  )

  useEffect(() => {
    debouncedFetchData.run()
  }, [filterDuration])

  return (
    <div className="card bg-white">
      <div className="flex h-[60px] items-start justify-between">
        <Link to="/instances">
          <div className="w-11 h-11 icon-btn">
            <LeftArrow />
          </div>
        </Link>
      </div>

      <Divider />

      <div className="h4">{instance?.displayTitle}</div>
      <div className="t-sm mt-0.5 flex gap-2 mb-8">
        <span className="text-secondary">{formatDomain(instance?.domain ?? 0)}</span>
        <span className="text-secondary">·</span>
        <span className={instance?.statusTextStyle}>{instance?.statusText}</span>
      </div>

      <div className="flex justify-between items-start mb-8">
        <div className="text-xl text-primary font-bold">Monitoring</div>
        <Radio.Group
          onChange={(e) => {
            setFilterDuration(e.target.value)
          }}
          value={filterDuration}
        >
          <Radio.Button value={TIME_UNITS_IN_SECONDS.HOUR}>Real-time</Radio.Button>
          <Radio.Button value={TIME_UNITS_IN_SECONDS.DAY}>1 Day</Radio.Button>
          <Radio.Button value={3 * TIME_UNITS_IN_SECONDS.DAY}>3 Days</Radio.Button>
        </Radio.Group>
      </div>

      {Array.isArray(monitorDatas) && monitorDatas.length > 0 ? (
        <div className=" text-tertiary gap-8 grid grid-cols-2">
          {monitorDatas.map((item: MonitorItemData) => {
            return (
              <div key={item.type} className=" ">
                <div className="mb-2 flex justify-between items-center">
                  <div className=" gap-1">
                    {item.title}
                    {item.description}
                  </div>
                  {item.realtime}
                </div>
                <Chart value={item}></Chart>
              </div>
            )
          })}
        </div>
      ) : (
        <div className="h-16 overflow-hidden mt-4 text-center text-tertiary t-sm">
          <Trans i18nKey="common.emptyViewNoDataMsg">No Data</Trans>
        </div>
      )}
    </div>
  )
}
